﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="26"
  viewBox="0 0 21 26"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="translate(-1.000000, 1.000000)">
    <g transform="translate(2.000000, 0.000000)">
      <path
        d="M18.807,4.5 C18.9945494,4.68749273 19.1,4.94180519 19.1,5.207
        L19.1,22.5 C19.1,23.0522847 18.6522847,23.5 18.1,23.5 L1.1,23.5
        C0.54771525,23.5 0.1,23.0522847 0.1,22.5 L0.1,1.5 C0.1,0.94771525
        0.54771525,0.5 1.1,0.5 L14.393,0.5 C14.6581948,0.5
        14.9125073,0.605450625 15.1,0.793 L18.807,4.5 Z"
        id="Path" />
      <line x1="3.6" y1="16" x2="15.6" y2="16" id="Path" />
      <line x1="3.6" y1="19" x2="15.6" y2="19" id="Path" />
      <line x1="3.6" y1="13" x2="15.6" y2="13" id="Path" />
      <line x1="3.6" y1="10" x2="15.6" y2="10" id="Path" />
      <line x1="3.6" y1="7" x2="10.6" y2="7" id="Path" />
      <line x1="3.6" y1="7" x2="10.6" y2="7" id="Path" />
      <line x1="3.6" y1="10" x2="15.6" y2="10" id="Path" />
      <line x1="3.6" y1="13" x2="15.6" y2="13" id="Path" />
      <line x1="3.6" y1="16" x2="15.6" y2="16" id="Path" />
      <line x1="3.6" y1="19" x2="15.6" y2="19" id="Path" />
    </g>
  </g>
</svg>
